import api from './api'
import type {
  ProfileUpdateRequestCreatePayload,
  ProfileUpdateRequestCreateResponse,
  ProfileUpdateRequestSnapshotIn,
} from 'models/ota/ProfileUpdateRequestModel'

const PROFILE_UPDATES_RESOURCE = 'profile_updates'

export const createProfileUpdateRequest = async (payload: ProfileUpdateRequestCreatePayload) => {
  return await api.post<ProfileUpdateRequestCreatePayload, ProfileUpdateRequestCreateResponse>(`${PROFILE_UPDATES_RESOURCE}/`, payload)
}

export const getLiveOrPendingProfileUpdateRequests = async (deploymentId: number) => {
  return await api.get<ProfileUpdateRequestSnapshotIn[]>(`${PROFILE_UPDATES_RESOURCE}/live_or_pending/`, { deployment_id: deploymentId })
}

export const dismissProfileUpdateRequest = async (requestId: number) => {
  return await api.post(`${PROFILE_UPDATES_RESOURCE}/${requestId}/dismiss/`)
}
